/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал опроса статусов сетевой доступности устройств
 */

/**
 * Сервис опроса статусов сетевой доступности устройств.
 * Авторизация:
 *   - Authorization: Bearer token.
 *   - X-Api-Key: apiKey
 */
export class DeviceStatusServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения списка статусов доступности устройств.
   * Метод доступен для: Token: service, admin. Без учета разрешений.
   * Метод доступен для: ApiKey: Разрешения: telemetry_status:device_status:list
   */
  GetDeviceStatusList = (req?: GetDeviceStatusListRequestDto, init?: RequestInit): Promise<GetDeviceStatusListResponseDto[]> => {
    return fm.list<GetDeviceStatusListRequestDto, GetDeviceStatusListResponseDto>(`${this.host}/telemetry_status/api/v1/device_status/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества статусов доступности устройств.
   * Метод доступен для: Token: service, admin. Без учета разрешений.
   * Метод доступен для: ApiKey: Разрешения: telemetry_status:device_status:list
   */
  GetDeviceStatusCount = (req?: GetDeviceStatusCountRequestDto, init?: RequestInit): Promise<GetDeviceStatusCountResponseDto> => {
    return fm.request<GetDeviceStatusCountRequestDto, GetDeviceStatusCountResponseDto>(`${this.host}/telemetry_status/api/v1/device_status/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов статусов
 */
export enum DeviceStatusStatusType {
  /**
   * Значение не указано.
   * Проверка доступности не выполнялась
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Не доступен
   */
  OFFLINE = "OFFLINE",
  /**
   * Доступен
   */
  ONLINE = "ONLINE",
}
/**
 * Справочник типов статусов
 */
export type DeviceStatusStatusTypeResponseEnum = keyof typeof DeviceStatusStatusType
/**
 * Справочник типов статусов
 */
export type DeviceStatusStatusTypeRequestEnum = Exclude<DeviceStatusStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum DeviceStatusPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type DeviceStatusPagingDirectionTypeResponseEnum = keyof typeof DeviceStatusPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type DeviceStatusPagingDirectionTypeRequestEnum = Exclude<DeviceStatusPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum DeviceStatusPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По дате проверки
   */
  CHECKED_AT = "CHECKED_AT",
  /**
   * По идентификатору
   */
  DEVICE_ID = "DEVICE_ID",
}
/**
 * Справочник типов значений сортировки
 */
export type DeviceStatusPagingOrderByTypeResponseEnum = keyof typeof DeviceStatusPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type DeviceStatusPagingOrderByTypeRequestEnum = Exclude<DeviceStatusPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Статус доступности устройства
 */
export type DeviceStatusRequestDto = {
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Статус доступности устройства
 */
export type DeviceStatusResponseDto = {
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * IP-адрес устройства
   */
  readonly ip: string
  /**
   * Момент проверки статуса
   */
  readonly checkedAt: string | null
  /**
   * Тип статуса
   */
  readonly statusType: DeviceStatusStatusTypeResponseEnum
}
/**
 * Фильтр для запроса статусов доступности устройств.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceStatusFilterRequestDto = {
  /**
   * По списку приборов учета
   */
  deviceIds?: number[]
  /**
   * По cтатусам доступности
   */
  statusTypes?: DeviceStatusStatusTypeResponseEnum[]
}
/**
 * Фильтр для запроса статусов доступности устройств.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DeviceStatusFilterResponseDto = {
  /**
   * По списку приборов учета
   */
  deviceIds: number[]
  /**
   * По cтатусам доступности
   */
  statusTypes: DeviceStatusStatusTypeResponseEnum[]
}
/**
 * Пагинация статусов сетевой доступности
 */
export type DeviceStatusPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: CHECKED_AT
   */
  orderByType?: DeviceStatusPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: DeviceStatusPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация статусов сетевой доступности
 */
export type DeviceStatusPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: CHECKED_AT
   */
  orderByType: DeviceStatusPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: DeviceStatusPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Запрос получения количества записей
 */
export type GetDeviceStatusCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: DeviceStatusFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества записей
 */
export type GetDeviceStatusCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего записей
   */
  readonly data: number
}>
/**
 * Запрос получения списка
 */
export type GetDeviceStatusListRequestDto = {
  /**
   * Фильтр
   */
  filter?: DeviceStatusFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: DeviceStatusPagingRequestDto
}>
/**
 * Ответ на запрос получения списка статусов доступности устройств
 */
export type GetDeviceStatusListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Статус доступности устройства
   */
  readonly data: DeviceStatusResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Статус доступности устройства
   */
  "DeviceStatus": {
    "kind": "class",
    "text": "Статус доступности устройства",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * IP-адрес устройства
       */
      "ip": {
        "type": "string",
        "text": "IP-адрес устройства",
      },
      /**
       * Момент проверки статуса
       */
      "checkedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Момент проверки статуса",
      },
      /**
       * Тип статуса
       */
      "statusType": {
        "type": "DeviceStatus.StatusType",
        "text": "Тип статуса",
      },
    },
  },
  /**
   * Фильтр для запроса статусов доступности устройств.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "DeviceStatusFilter": {
    "kind": "class",
    "text": "Фильтр для запроса статусов доступности устройств.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По списку приборов учета
       */
      "deviceIds": {
        "type": "int32",
        "text": "По списку приборов учета",
      },
      /**
       * По cтатусам доступности
       */
      "statusTypes": {
        "type": "DeviceStatus.StatusType",
        "text": "По cтатусам доступности",
      },
    },
  },
  /**
   * Пагинация статусов сетевой доступности
   */
  "DeviceStatusPaging": {
    "kind": "class",
    "text": "Пагинация статусов сетевой доступности",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: CHECKED_AT
       */
      "orderByType": {
        "type": "DeviceStatusPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: CHECKED_AT",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "DeviceStatusPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Запрос получения количества записей
   */
  "GetDeviceStatusCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества записей",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DeviceStatusFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества записей
   */
  "GetDeviceStatusCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества записей",
    "fields": {
      /**
       * Всего записей
       */
      "data": {
        "type": "int32",
        "text": "Всего записей",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetDeviceStatusListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DeviceStatusFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "DeviceStatusPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка статусов доступности устройств
   */
  "GetDeviceStatusListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка статусов доступности устройств",
    "fields": {
      /**
       * Статус доступности устройства
       */
      "data": {
        "type": "DeviceStatus",
        "text": "Статус доступности устройства",
      },
    },
  },
  /**
   * Справочник типов статусов
   */
  "DeviceStatus.StatusType": {
    "kind": "enum",
    "text": "Справочник типов статусов",
    "values": {
      /**
       * Значение не указано.
       * Проверка доступности не выполнялась
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано.\nПроверка доступности не выполнялась",
      },
      /**
       * Не доступен
       */
      "OFFLINE": {
        "i": 1,
        "text": "Не доступен",
      },
      /**
       * Доступен
       */
      "ONLINE": {
        "i": 2,
        "text": "Доступен",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "DeviceStatusPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "DeviceStatusPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По дате проверки
       */
      "CHECKED_AT": {
        "i": 1,
        "text": "По дате проверки",
      },
      /**
       * По идентификатору
       */
      "DEVICE_ID": {
        "i": 2,
        "text": "По идентификатору",
      },
    },
  },
}